import useSWR from "swr";
import spreadKeyFetcher from "./spreadKeyFetcher";
const useSWRFetch = (options, fetcher, fetcherOptions) => {
  const { data, error, mutate } = useSWR(options, spreadKeyFetcher(fetcher), fetcherOptions);
  return { data, isLoading: !error && !data, error, mutate };
};

export default useSWRFetch;
